import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, Validators, FormBuilder, AbstractControl } from '@angular/forms';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import * as moment from "moment-timezone";
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { ServiceAreasService } from 'src/app/component/service-areas/service-areas-service/service-areas.service';
import { sweetAlert } from 'src/app/utils/swal';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { LevelOfServiceService } from 'src/app/component/level-of-service/service/level-of-service.service';
import { FundingsourcestoreService } from '../../services/store/fundingsource-store/fundingsource-store.service';
import { ServiceareaStoreService } from '../../services/store/servicearea-store/servicearea-store.service';
import { SpaceTypeStoreService } from '../../services/store/spacetype-store/spacetype-store.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SearchStoreService } from '../../services/store/search-store/search-store.service';

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.css']
})
export class SearchFilterComponent implements OnInit {
  @Output() search = new EventEmitter<any>();
  @Output() filter = new EventEmitter<string>();
  inputChangeSubject = new Subject<string>();
  timeZone: any;
  user: any;
  serviceAreas: any = [];
  corporates: any = [];
  spaceTypes: any = [];
  infoModal = false;

  searchForm: FormGroup;

  constructor(
    private sharedDataService: SharedDataService,
    private fundingSourceStore: FundingsourcestoreService,
    private spaceTypeStore: SpaceTypeStoreService,
    private serviceAreasStore: ServiceareaStoreService,
    private searchStore: SearchStoreService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.searchForm = this.fb.group({
      preDate: [""],
      date: [[], Validators.required],
      cooperates: [[], Validators.required],
      serviceAreas: [[], Validators.required],
      spaceTypes: [[], Validators.required],
      reference: ["", Validators.required],
    });

    this.getUser();

    this.fundingSourceStore.state$.subscribe((res) => {
      if (res) {
        this.corporates = res;
      }
    }
    );

    this.spaceTypeStore.state$.subscribe((res) => {
      if (res) {
        this.spaceTypes = res;
      }
    }
    );

    this.serviceAreasStore.state$.subscribe((res) => {
      if (res) {
        this.serviceAreas = res;
      }
    }
    );

    this.inputChangeSubject.pipe(debounceTime(1000)).subscribe((search) => {
      if (search.length >= 3){
        if(!search.includes(":")) return;
        const searchKey = search.split(":")[0];
        const searchValue = search.split(":")[1];
        const data:any = {
          [searchKey]: searchValue,
          scheduleTime: this.searchForm.value.date.toString(),
        }
        this.filter.emit(data);
        this.searchForm.patchValue({
          cooperates: [[]],
          serviceAreas: [[]],
          spaceTypes: [[]],
          reference: [''],
        });
      }
    });

  }


  get form() {
    return this.searchForm.controls;
  }


  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((user) => {
        if (user) {
          this.user = user;
          this.timeZone = user.company ? user.company.timeZone : user.timeZone;
          this.searchForm.patchValue({
            preDate: moment.tz(this.timeZone).startOf("day"),
            date: [moment.tz(this.timeZone).startOf("day").toISOString(), moment.tz(this.timeZone).endOf("day").toISOString()],
          })
        }
      });
  }

  onSubmit() {
    this.searchStore.setEntities(this.searchForm.value)
  }

  onDateChange(evt) {
    if (evt) {
      this.searchForm.patchValue({
        date: [evt.startOf("day").toISOString(), evt.endOf("day").toISOString()]
      });
    }
  }


  onInputChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.inputChangeSubject.next(value);
  }

  openInfoModal() {
    this.infoModal = true;
  }
  ngOnDestroy(): void {

  }

}
